<!-- HM policy -->
<template>
  <component :is="component" :policy="policy" v-if="component" />
</template>

<script>
import { policyService } from '@/services'

export default {
  name: 'HMPolicy',
  props: {
    policy: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  inject: ['$validator'],
  data() {
    return {
      component: null
    }
  },
  methods: {
    loadPolicy() {
      if (this.policy && this.policy.file) {
        policyService.getPolicyFile(this.policy)
          .then(data => {
            let editable = this.editable;

            // make a custom component with the policy file as the template
            this.component = {
              template: '<div>' + data + '</div>',
              props: ['policy'],
              inject: ['$validator'],
              data() {
                return {
                  editable: editable
                };
              },
              methods: {
                checkValueIsSet(object, key, value) {
                  // check if key exists, set value only if not already set
                  // note: this is to get around checkbox issue where if value is not set (null) it defaults to checked (true)
                  if (!object.hasOwnProperty(key)) {
                    console.log('Policy: Setting key [%s] to value [%s]', key, value);
                    this.$set(object, key, value); // must use Vue.set to get things to be reactive to the change
                    // object[key] = value;
                  }
                  return true;
                }
              }
            }
          })
      }
    }
  },
  mounted() {
    this.loadPolicy();
  },
  watch: { // you have to use function syntax here, as warned in the docs
    'policy': function (newVal, oldVal) {
      this.loadPolicy();
    }
  }
}
</script>

<style lang="scss">
// import variables for this application
@import '@/assets/scss/_variables.scss';

.policy-highlight {
  color: $highlight-color;
  background-color: $highlight-bg;
  display: inline;
}
.policy-highlight-pre {
  color: $highlight-color;
  background-color: $highlight-bg;
  white-space: pre-wrap;
}
.policy-highlight::placeholder {
  color: $brand-info;
}
.policy-highlight::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: $brand-info;
}
.policy-highlight::-moz-placeholder {
  /* Firefox 19+ */
  color: $brand-info;
}
.policy-highlight:-ms-input-placeholder {
  /* IE 10+ */
  color: $brand-info;
}
.policy-highlight:-moz-placeholder {
  /* Firefox 18- */
  color: $brand-info;
}
.policy-invalid {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  display: inline;
}
</style>